/* eslint-disable max-params */
export const findByKey = (array = [], key, value, cb) => {
    for (let i = 0; i < array.length; i++) {
        if (typeof cb === "function" ? cb(array[i][key], value) : array[i][key] === value) {
            return {...array[i], itemIndex: i};
        }
    }
    return {};
};
